<template>
  <div class="header-sub-menu__container">
    <div style="display:flex; align-items: center;" ref="subMenu" :key="subMenuKey">
        <HeaderSubMenuItem
          v-for="(subMenu, index) in options.listMenus.items"
          :key="index" :title="subMenu.title"
          :path="subMenu.path"
          :class="{ active: $route.matched.some(({ path }) => path === subMenu.path) }"
          v-show="isAccessible(subMenu.permissionIds)"/>
        <b-dropdown  class="sub-menu-dropdown" boundary="viewport" v-if="options.dropDownMenus.items.length > 0">
          <template #button-content>
            <div class="custom-dropwdown_button-content ">More<v-icon name="caret-down" class="ml-2"/></div>
          </template>
          <b-dropdown-item
            v-for="(dropDownMenu, index) in options.dropDownMenus.items" :key="index"
            @click="$router.replace(dropDownMenu.path)">
            {{ dropDownMenu.title }}
          </b-dropdown-item>
        </b-dropdown>
    </div>
  </div>
</template>

<script>
import Access from '../../mixins/utils/Access'
import HeaderSubMenuItem from './HeaderSubMenuItem'
export default {
  components: {
    HeaderSubMenuItem
  },
  mixins: [ Access ],
  props: {
    subMenus: {
      type: Array,
    }
  },
  data() {
    return {
      subMenuKey: 0,
      windowWidth: window.innerWidth,
      options: {
        dropDownMenus: {
          items: []
        },
        listMenus: {
          items:[ ...this.subMenus ]
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
      this.filterMenus()
    })
  },
  computed: {
    cutOffIndex() {
      let canvas = document.createElement("canvas")
      let context = canvas.getContext('2d')
      context.font = "bold 12px sans-serif"
      let width = 0
      let cutOffIndex = 0
      if(this.accessibleMenus) {
        this.accessibleMenus.every(menu => {
          width += (context.measureText(menu.title.toUpperCase()).width + 20)
          if((width + 200) > this.windowWidth) {
            cutOffIndex = this.accessibleMenus.indexOf(menu)
            return false
          }
          return true
        })
      }
      return cutOffIndex
    },
    accessibleMenus() {
      return this.subMenus.filter(subMenu => this.isAccessible(subMenu.permissionIds))
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
      this.filterMenus()
    },
    filterMenus() {
      const { listMenus, dropDownMenus } = this.options
        if(this.cutOffIndex != 0) {
          if(this.accessibleMenus) {
            listMenus.items = this.accessibleMenus.slice(0, this.cutOffIndex);
            dropDownMenus.items = this.accessibleMenus.slice(listMenus.items.length, this.accessibleMenus.length);
          }
        }
        else {
          listMenus.items = this.accessibleMenus
          dropDownMenus.items = []
        }
      this.subMenuKey += 1
    },
  },
  watch: {
    accessibleMenus : function(value) {
      this.filterMenus()
    }
  }
}

</script>

<style lang="scss" scoped>
  .header-sub-menu__container {
    height: 60px;
    width: 100%;
    display: flex;
    background-color: white;
    // border-top: solid 1px gray;
    border-bottom: solid 1px gray;
    padding: 0 20px;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch; /* Lets it scroll lazy */
    flex: 0 0 auto;
    max-width: 100vw;

    
  }

  // ::-webkit-scrollbar {
  //   height: 6px;
  // }

  // /* Track */
  // ::-webkit-scrollbar-track {
  //   background: #f1f1f1;
  // }

  // /* Handle */
  // ::-webkit-scrollbar-thumb {
  //   background: #888;
  // }

  // /* Handle on hover */
  // ::-webkit-scrollbar-thumb:hover {
  //   background: #555;
  // }
</style>